export default {
	label: 'Document | Documents',
	name: 'Name',
	length: 'Size',
	added: 'Added',
	addedUser: 'Added by user',
	reference: 'Referenced',
	replace: 'Replace',
	download: 'Download',
	folderName: 'Folder name',
	cantRemove: 'Only empty folders can be removed!',
	cantAdd: 'Documents cannot be added in All Instances view!',
	cantAdd2: 'Missing permissions for adding a new document!',
	with: 'with document',
	add: 'Add document',
	addURL: 'Add link',
	url: 'Link',
	editUrl: 'Edit link',
	select: 'Select document',
	selectUrl: 'Select link',
	successfullyMoved: 'Document successfully moved',
	successfullyReplaced: 'Document successfully replaced',
	move: 'Move document',
	selectNewDirectory: 'Select new directory',
	references: {
		title: 'References',
		empty: 'No references',
		deleteWarning:
			'This item is referenced by the objects below. Deleting it will remove those references. To keep them, cancel and use Replace instead.',
		deleteAnyway: 'Delete anyway',
	},
	referenceTypes: {
		standard_method_meta_data: 'Measure',
		method: 'Measure',
		business_processes: 'Business process',
		assets: 'Asset',
		data_assets: 'Data asset',
		module_meta: 'Module',
		risk_meta: 'Risk',
		threat_meta: 'Threat',
		vulnerability_meta: 'Vulnerability',
	},
}
